import React, { useContext, useMemo } from 'react';
import { Progress, Spin } from 'antd';
import { GasMonitorContext } from '../../../context';
import styles from './index.module.scss';
import { isEmpty } from 'lodash-es';
import { Empty } from '@maxtropy/components';
import { formatThousandUnit, keepOnePercentOrLine } from '@/utils/utils';
import { IndexTimeActive } from '../SwitchDate';

// Circular progress ring component
const CircularProgress: React.FC<{ percent?: number }> = ({ percent }) => {
  return (
    <div className={styles.ringWrapper}>
      <Progress
        type="circle"
        size={50}
        strokeWidth={8}
        percent={(percent ?? 0) * 100}
        trailColor="#4A90E233"
        showInfo={false}
        strokeColor="#5BFF60"
      />
      <span className={styles.ringPercent}>{keepOnePercentOrLine(percent)}%</span>
    </div>
  );
};

const GasTypeCards: React.FC = () => {
  const { timeResolution, energyUsageData: data, energyUsageLoading: loading } = useContext(GasMonitorContext);

  const gasList = useMemo(() => {
    return data?.list ?? [];
  }, [data]);

  return (
    <div className={styles.gasCardsContainer}>
      <Spin spinning={loading}>
        {isEmpty(gasList) ? (
          <Empty style={{ marginTop: 100 }} />
        ) : (
          gasList.map((gas, index) => {
            return (
              <div key={gas.mediumId ?? index} className={styles.gasSection}>
                <div className={styles.gasSectionHeader}>{gas.mediumName ?? '--'}</div>
                <div className={styles.gasCardBody}>
                  <CircularProgress percent={gas.gasUsageProportion} />
                  <div className={styles.gasDataArea}>
                    <div className={styles.dataRow}>
                      <span className={styles.label}>
                        {timeResolution === IndexTimeActive.THIS_MONTH ? '本月' : '本年'}实际(
                        {gas.physicalUnitName ?? '--'})：
                      </span>
                      <span className={styles.value} style={{ color: '#57FB8B' }}>
                        {formatThousandUnit(gas.gasUsage)}
                      </span>
                    </div>
                    <div className={styles.dataRow}>
                      <span className={styles.label}>
                        {timeResolution === IndexTimeActive.THIS_MONTH ? '本月' : '本年'}计划(
                        {gas.physicalUnitName ?? '--'})：
                      </span>
                      <span className={styles.value} style={{ color: '#FFCB47' }}>
                        {formatThousandUnit(gas.gasPlanUsage)}
                      </span>
                    </div>
                  </div>
                  <div className={styles.costBadge}>
                    成本(元)
                    <div className={styles.costValue}>{formatThousandUnit(gas.cost)}</div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </Spin>
    </div>
  );
};

export default GasTypeCards;
